import React from 'react'
import IconBase from './IconBase'

const Up = props => (
  <IconBase viewBox="0 0 41 24" {...props}>
    <path d="M22.5 1.3l17.2 17.3c1.1 1.1 1.1 2.9 0 4a2.84 2.84 0 0 1-4 0L20.5 7.3 5.3 22.5c-1.1 1.1-2.9 1.1-4 0s-1.1-2.9 0-4L18.5 1.3c1.1-1.1 2.9-1.1 4 0z" />
  </IconBase>
)

export default Up
